export default __webpack_public_path__ + "static/media/collected-coin.f724175b.svg";